export const accommodationDestination = {
  ACCOMMODATION_DESTINATION_BUTTON: 'accommodationDestination.button'
}
